import get from 'lodash/get';
import { connect } from 'react-redux';
import RankingDetails from './RankingDetails';

import { getRankingById } from '../../service/ranking';

export const loadRanking = id => (dispatch, getState) => {
  let { jwToken } = getState();

  return getRankingById(jwToken, id).then(res => {
    dispatch({
      type: 'RANKING_DETAILS_SET',
      payload: get(res, 'data', {})
    });
    return res;
  });
};

export const mapStateToProps = ({ rankingDetails, location }) => {
  const currentRankingId = location?.payload?.id;
  const hasCurrentData =
    !!currentRankingId && rankingDetails?._id === currentRankingId;
  const notFound = !!rankingDetails?.notFound && rankingDetails?.requestedId === currentRankingId;

  return {
    ...rankingDetails,
    notFound,
    isCurrentDataReady: hasCurrentData || notFound,
  };
};

export default connect(mapStateToProps)(RankingDetails);
